import { render } from "./PlaceTable.vue?vue&type=template&id=7663b900&scoped=true"
import script from "./PlaceTable.vue?vue&type=script&lang=js"
export * from "./PlaceTable.vue?vue&type=script&lang=js"

import "./PlaceTable.vue?vue&type=style&index=0&id=7663b900&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7663b900"]])

export default __exports__